import toURL from '@homeaway/search-url-parser/dist/transpiled/toURL';
import Cookies from 'js-cookie';
import { SEARCH_COOKIE } from '../../config/constants';

export const getURLWithCookieDetails = (locationQuery) => {
  const searchCookie = Cookies.getJSON(SEARCH_COOKIE) || {
    arrival: '',
    departure: ''
  };

  const {
    arrival,
    departure,
    numberOfAdults,
    numberOfChildren,
    petIncluded
  } = searchCookie;

  const searchRequest = {
    q: locationQuery,
    adultsCount: numberOfAdults,
    childrenCount: numberOfChildren,
    petIncluded,
    arrival,
    departure
  };

  return toURL(searchRequest);
};
